module.exports = __webpack_public_path__ + "static/media/Heroku-icon.a5c4fdd3.svg";